module.exports = __webpack_public_path__ + "static/media/bm-ortofoto.2ed738f5.png";